// import dotenv from 'dotenv';
import { useState, useEffect } from "react";


// dotenv.config();


const WeatherAndYt = () => {

    const [weather, setWeather] = useState(null)
    const [wName, setWName] = useState('')

    useEffect(() => {
        async function getWeather() {
            const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=Kishtwar&units=metric&appid=c80b4610362653b47dfea65c38fb99be`)
            const data = await response.json();
            setWeather(data)
        }

        getWeather()


        if (weather) {
            const wth = weather.weather[0].description;
            // if (wth === 'clear sky') {
            //   setWName('sunny');
            // } else 
            if (wth === 'few clouds') {
              setWName('partly_cloudy_day');
            } else if (wth === 'scattered clouds') {
              setWName('cloudy');
            } else if (wth === 'broken clouds') {
              setWName('cloudy');
            } else if (wth === 'rain') {
              setWName('rainy');
            } else if (wth === 'thunderstorm') {
              setWName('thunderstorm');
            } else if (wth === 'snow') {
              setWName('cloudy_snowing');
            } else {
              setWName('wth');
            }
          }


        
    }, [weather])

    

    if (!weather) {
        return <div>Loading...</div>   
    }


    return ( 
        <div className="apis">
            <div className="container">
            <div className="weather" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h1>Current weather in {weather.name}</h1>
                <p style={{margin: 0, textAlign: 'center'}}><span class="material-symbols-outlined" style={{fontSize: "4em"}}>{wName}</span></p>

                <p>{weather.main.temp}° C</p>
                <p>Humidity: {weather.main.humidity}</p>
            </div>

            <div className="youtube">
            <iframe 
            
            src="https://www.youtube.com/embed/jCS2NcrRyb8" 
            title="My recent youtube video" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen></iframe>
            </div>
            </div>
        </div>
        
     );
}
 
export default WeatherAndYt;